<template>
  <div class="modalContents__object08">
    <div class="container">
      <div class="row no-gutters">
        <div class="col-xl-5 col-lg-6 col-md-8 col-10 mx-auto">
          <h2 class="text-center">LOST PASSWORD</h2>
          <p>
            ご登録いただいたパスワードをお忘れの方は、下記のフォームにログインID (メールアドレス or
            電話番号)を入力の上、送信してください。新しいパスワードを作成するためのリンクをメールでお送りします。メールが届きましたら、記載しているURLより、パスワードの再設定をお願い致します。
          </p>
          <p>ログインID (メールアドレス or 電話番号)もご不明な場合は、お電話にてお問い合わせください。
            <br>
            <em>
              <a href="tel:03-6721-1468">03-6721-1468</a>
            </em>
          </p>
          <form class="row no-gutters" @submit.prevent="send">
            <!-- メール -->
            <div class="col-12">
              <label for="bemailReset">ログインID (メールアドレス or 電話番号)</label>
              <input
                type="email"
                name="bemailReset"
                id="bemailReset"
                class="form-control"
                placeholder="LOGIN ID"
                required
                v-model="account"
              >
            </div>
            <!-- 送信ボタン -->
            <div class="col-12">
              <button class="text-center btn globalModal--btn" id="resetPassSubmit">送信</button>
            </div>
          </form>
          <div class="modalContents__object08__btn">
            <a class="globalModal--btn" title="close" @click='hideModal'>
              <span class="fa-stack fa-lg">
                <i class="fa fa-circle-thin fa-stack-2x fa-inverse" aria-hidden="true"></i>
                <i class="fa fa-times fa-stack-1x fa-inverse" aria-hidden="true"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import MultiModalMixin from "../mixins/ModalMixin";

export default {
  name: "LostPassword",
  data : function(){
    return {
      account:'',
    }
  },
  mixins: [MultiModalMixin],
  methods:{
    send(){
      var params = {
        account : this.account,
      }
      axios
          .post('/auth/reset_password',params)
          .then(response => {
            if(response.status == 200){
              // 送信完了
              console.log('contact submited')
            }
          })
          .catch(error => console.log(error))

      this.showModalLostPasswordThanks()
      return false;
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/lost_password.vue